import { Component, ElementRef, EventEmitter, Directive, TemplateRef, ViewContainerRef, ComponentFactoryResolver, Renderer2, NgZone, Inject, PLATFORM_ID, Input, Output, NgModule } from '@angular/core';
import { ResizeObserver as ResizeObserver$1 } from '@juggle/resize-observer';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
class NestedEllipsisContentComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
}
NestedEllipsisContentComponent.ɵfac = function NestedEllipsisContentComponent_Factory(t) { return new (t || NestedEllipsisContentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NestedEllipsisContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NestedEllipsisContentComponent, selectors: [["nested-ellipsis-content"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function NestedEllipsisContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%] {\n      display: block;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n    }"] });
NestedEllipsisContentComponent.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NestedEllipsisContentComponent, [{
        type: Component,
        args: [{
                selector: 'nested-ellipsis-content',
                template: `
    <ng-content></ng-content>
  `,
                styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

let ResizeObserver = ResizeObserver$1;
/**
 * Directive to truncate the contained text, if it exceeds the element's boundaries
 * and append characters (configurable, default '...') if so.
 */
class NestedEllipsisDirective {
    /**
     * The directive's constructor
     */
    constructor(templateRef, viewContainer, resolver, renderer, ngZone, platformId) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.resolver = resolver;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.platformId = platformId;
        /**
         * Subject triggered when resize listeners should be removed
         */
        this.removeResizeListeners$ = new Subject();
        /**
         * The ellipsisChange html attribute
         * This emits after which index the text has been truncated.
         * If it hasn't been truncated, null is emitted.
         */
        this.change = new EventEmitter();
    }
    /**
     * Utility method to quickly find the largest number for
     * which `callback(number)` still returns true.
     * @param  max      Highest possible number
     * @param  callback Should return true as long as the passed number is valid
     * @returns         Largest possible number
     */
    static numericBinarySearch(max, callback) {
        let low = 0;
        let high = max;
        let best = -1;
        let mid;
        while (low <= high) {
            mid = Math.floor((low + high) / 2);
            const result = callback(mid);
            if (!result) {
                high = mid - 1;
            }
            else {
                best = mid;
                low = mid + 1;
            }
        }
        return best;
    }
    flattenTextAndElementNodes(element) {
        const nodes = [];
        for (let i = 0; i < element.childNodes.length; i++) {
            const child = element.childNodes.item(i);
            if (child instanceof HTMLElement || child instanceof CharacterData) {
                nodes.push(child);
                if (child instanceof HTMLElement) {
                    nodes.push(...this.flattenTextAndElementNodes(child));
                }
            }
        }
        return nodes;
    }
    /**
     * Angular's onInit life cycle hook.
     * Initializes the element for displaying the ellipsis.
     */
    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            // in angular universal we don't have access to the ugly
            // DOM manipulation properties we sadly need to access here,
            // so wait until we're in the browser:
            return;
        }
        // Prefer native ResizeObserver over ponyfill, if available:
        if (window.ResizeObserver != null) {
            ResizeObserver = window.ResizeObserver;
        }
        if (typeof (this.active) !== 'boolean') {
            this.active = true;
        }
        if (typeof (this.indicator) === 'undefined') {
            this.indicator = '...';
        }
        if (typeof (this.resizeDetection) === 'undefined') {
            this.resizeDetection = "resize-observer" /* ResizeObserver */;
        }
        // perform regex replace on word boundaries:
        if (!this.wordBoundaries) {
            this.wordBoundaries = '';
        }
        this.wordBoundaries = '[' + this.wordBoundaries.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ']';
        // initialize view:
        this.compFactory = this.resolver.resolveComponentFactory(NestedEllipsisContentComponent);
        this.restoreView();
        this.previousDimensions = {
            width: this.elem.clientWidth,
            height: this.elem.clientHeight,
            scrollWidth: this.elem.scrollWidth,
            scrollHeight: this.elem.scrollHeight
        };
        this.applyEllipsis();
    }
    /**
     * Angular's destroy life cycle hook.
     * Remove event listeners
     */
    ngOnDestroy() {
        this.removeResizeListeners$.next();
        this.removeResizeListeners$.complete();
    }
    /**
     * Angular's afterViewChecked life cycle hook.
     * Reapply ellipsis, if any of the templates have changed
     */
    ngAfterViewChecked() {
        if (this.resizeDetection !== 'manual') {
            if (this.templatesHaveChanged) {
                this.applyEllipsis();
            }
        }
    }
    /**
     * Convert a list of Nodes to html
     * @param nodes Nodes to convert
     * @returns html code
     */
    nodesToHtml(nodes) {
        const div = this.renderer.createElement('div');
        for (const node of nodes) {
            this.renderer.appendChild(div, node.cloneNode(true));
        }
        return div.innerHTML;
    }
    /**
     * Convert the passed templates to html
     * @param templateView the main template view ref
     * @param indicatorView the indicator template view ref
     * @returns concatenated template html
     */
    templatesToHtml(templateView, indicatorView) {
        let html = this.nodesToHtml(templateView.rootNodes);
        if (indicatorView) {
            html += this.nodesToHtml(indicatorView.rootNodes);
        }
        else {
            html += this.indicator;
        }
        return html;
    }
    /**
     * Whether any of the passed templates have changed since the last time
     * the ellipsis has been applied
     */
    get templatesHaveChanged() {
        if (!this.templateView || !this.previousTemplateHtml) {
            return false;
        }
        const templateView = this.templateRef.createEmbeddedView({});
        templateView.detectChanges();
        const indicatorView = (typeof this.indicator !== 'string') ? this.indicator.createEmbeddedView({}) : null;
        if (indicatorView) {
            indicatorView.detectChanges();
        }
        const templateHtml = this.templatesToHtml(templateView, indicatorView);
        return this.previousTemplateHtml !== templateHtml;
    }
    /**
     * Restore the view from the templates (non-truncated)
     */
    restoreView() {
        this.viewContainer.clear();
        this.templateView = this.templateRef.createEmbeddedView({});
        this.templateView.detectChanges();
        const componentRef = this.viewContainer.createComponent(this.compFactory, null, this.viewContainer.injector, [this.templateView.rootNodes]);
        this.elem = componentRef.instance.elementRef.nativeElement;
        this.initialTextLength = this.currentLength;
        this.indicatorView = (typeof this.indicator !== 'string') ? this.indicator.createEmbeddedView({}) : null;
        if (this.indicatorView) {
            this.indicatorView.detectChanges();
        }
    }
    /**
     * Set up an event listener to call applyEllipsis() whenever a resize has been registered.
     * The type of the listener (window/element) depends on the `ellipsisResizeDetection`.
     */
    addResizeListener() {
        switch (this.resizeDetection) {
            case "manual" /* Manual */:
                // Users will trigger applyEllipsis via the public API
                break;
            case "window" /* Window */:
                this.addWindowResizeListener();
                break;
            default:
                if (typeof (console) !== 'undefined') {
                    console.warn(`
            No such ellipsisResizeDetection strategy: '${this.resizeDetection}'.
            Using '${"resize-observer" /* ResizeObserver */}' instead.
          `);
                }
                this.resizeDetection = "resize-observer" /* ResizeObserver */;
            // eslint-disable-next-line no-fallthrough
            case "resize-observer" /* ResizeObserver */:
                this.addResizeObserver();
                break;
        }
    }
    /**
     * Set up an event listener to call applyEllipsis() whenever the window gets resized.
     */
    addWindowResizeListener() {
        const removeWindowResizeListener = this.renderer.listen('window', 'resize', () => {
            this.ngZone.run(() => {
                this.applyEllipsis();
            });
        });
        this.removeResizeListeners$.pipe(take(1)).subscribe(() => removeWindowResizeListener());
    }
    /**
     * Set up an event listener to call applyEllipsis() whenever ResizeObserver is triggered for the element.
     */
    addResizeObserver() {
        const resizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
                if (this.previousDimensions.width !== this.elem.clientWidth
                    || this.previousDimensions.height !== this.elem.clientHeight
                    || this.previousDimensions.scrollWidth !== this.elem.scrollWidth
                    || this.previousDimensions.scrollHeight !== this.elem.scrollHeight) {
                    this.ngZone.run(() => {
                        this.applyEllipsis();
                    });
                    this.previousDimensions.width = this.elem.clientWidth;
                    this.previousDimensions.height = this.elem.clientHeight;
                    this.previousDimensions.scrollWidth = this.elem.scrollWidth;
                    this.previousDimensions.scrollHeight = this.elem.scrollHeight;
                }
            });
        });
        resizeObserver.observe(this.elem);
        this.removeResizeListeners$.pipe(take(1)).subscribe(() => resizeObserver.disconnect());
    }
    /**
     * Get the original text's truncated version. If the text really needed to
     * be truncated, this.ellipsisCharacters will be appended.
     * @param max the maximum length the text may have
     * @returns the text node that has been truncated or null if truncating wasn't required
     */
    truncateContents(max) {
        this.restoreView();
        const nodes = this.flattenTextAndElementNodes(this.elem)
            .filter(node => [Node.TEXT_NODE, Node.ELEMENT_NODE].includes(node.nodeType));
        let foundIndex = -1;
        let foundNode;
        let offset = this.initialTextLength;
        for (let i = nodes.length - 1; i >= 0; i--) {
            const node = nodes[i];
            if (node instanceof CharacterData) {
                offset -= node.data.length;
            }
            else {
                offset--;
            }
            if (offset <= max) {
                if (node instanceof CharacterData) {
                    if (this.wordBoundaries === '[]' && !this.mayTruncateAtFn) {
                        node.data = node.data.substr(0, max - offset);
                    }
                    else if (max - offset !== node.data.length) {
                        let j = max - offset - 1;
                        while (j > 0 && ((this.wordBoundaries !== '[]' && !node.data.charAt(j).match(this.wordBoundaries)) ||
                            (this.mayTruncateAtFn && !this.mayTruncateAtFn(node, j)))) {
                            j--;
                        }
                        if (offset > 0 && j === 0) {
                            continue;
                        }
                        node.data = node.data.substr(0, j);
                    }
                }
                foundIndex = i;
                foundNode = node;
                break;
            }
        }
        for (let i = foundIndex + 1; i < nodes.length; i++) {
            const node = nodes[i];
            if (node.textContent !== '' && node.parentNode !== this.elem && node.parentNode.childNodes.length === 1) {
                this.renderer.removeChild(node.parentNode.parentNode, node.parentNode);
            }
            else {
                this.renderer.removeChild(node.parentNode, node);
            }
        }
        return (this.currentLength !== this.initialTextLength) ? foundNode : null;
    }
    get currentLength() {
        return this.flattenTextAndElementNodes(this.elem)
            .filter(node => [Node.TEXT_NODE, Node.ELEMENT_NODE].includes(node.nodeType))
            .map(node => (node instanceof CharacterData) ? node.data.length : 1)
            .reduce((sum, length) => sum + length, 0);
    }
    /**
     * Set the truncated text to be displayed in the inner div
     * @param max the maximum length the text may have
     * @param addMoreListener=false listen for click on the ellipsisCharacters anchor tag if the text has been truncated
     */
    truncateText(max) {
        const truncatedNode = this.truncateContents(max);
        if (truncatedNode) {
            if (!this.indicatorView) {
                if (truncatedNode instanceof CharacterData) {
                    truncatedNode.data += this.indicator;
                }
                else {
                    this.renderer.appendChild(this.elem, this.renderer.createText(this.indicator));
                }
            }
            else {
                for (const node of this.indicatorView.rootNodes) {
                    this.renderer.appendChild(this.elem, node);
                }
            }
        }
    }
    /**
     * Display ellipsis in the EllipsisContentComponent if the text would exceed the boundaries
     */
    applyEllipsis() {
        // Remove the resize listener as changing the contained text would trigger events:
        this.removeResizeListeners$.next();
        // update from templates:
        this.restoreView();
        // remember template state:
        this.previousTemplateHtml = this.templatesToHtml(this.templateView, this.indicatorView);
        // abort if [nestedEllipsis]="false" has been set
        if (!this.active) {
            return;
        }
        // Find the best length by trial and error:
        const maxLength = NestedEllipsisDirective.numericBinarySearch(this.initialTextLength, curLength => {
            this.truncateText(curLength);
            return !this.isOverflowing;
        });
        // Apply the best length:
        this.truncateText(maxLength);
        // Re-attach the resize listener:
        this.addResizeListener();
        // Emit change event:
        if (this.change.observers.length > 0) {
            const currentLength = this.currentLength;
            this.change.emit((currentLength === this.initialTextLength) ? null : currentLength);
        }
    }
    /**
     * Whether the text is exceeding the element's boundaries or not
     */
    get isOverflowing() {
        // Enforce hidden overflow (required to compare client width/height with scroll width/height)
        const currentOverflow = this.elem.style.overflow;
        if (!currentOverflow || currentOverflow === 'visible') {
            this.elem.style.overflow = 'hidden';
        }
        const isOverflowing = this.elem.clientWidth < this.elem.scrollWidth - 1 || this.elem.clientHeight < this.elem.scrollHeight - 1;
        // Reset overflow to the original configuration:
        this.elem.style.overflow = currentOverflow;
        return isOverflowing;
    }
}
NestedEllipsisDirective.ɵfac = function NestedEllipsisDirective_Factory(t) { return new (t || NestedEllipsisDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NestedEllipsisDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NestedEllipsisDirective, selectors: [["", "nestedEllipsis", ""]], inputs: { active: ["nestedEllipsis", "active"], indicator: ["nestedEllipsisIndicator", "indicator"], resizeDetection: ["nestedEllipsisResizeDetection", "resizeDetection"], wordBoundaries: ["nestedEllipsisWordBoundaries", "wordBoundaries"], mayTruncateAtFn: ["nestedEllipsisMayTruncateAtFn", "mayTruncateAtFn"] }, outputs: { change: "nestedEllipsisChange" }, exportAs: ["ngxNestedEllipsis"] });
NestedEllipsisDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver },
    { type: Renderer2 },
    { type: NgZone },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
NestedEllipsisDirective.propDecorators = {
    active: [{ type: Input, args: ['nestedEllipsis',] }],
    indicator: [{ type: Input, args: ['nestedEllipsisIndicator',] }],
    wordBoundaries: [{ type: Input, args: ['nestedEllipsisWordBoundaries',] }],
    mayTruncateAtFn: [{ type: Input, args: ['nestedEllipsisMayTruncateAtFn',] }],
    resizeDetection: [{ type: Input, args: ['nestedEllipsisResizeDetection',] }],
    change: [{ type: Output, args: ['nestedEllipsisChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NestedEllipsisDirective, [{
        type: Directive,
        args: [{
                selector: '[nestedEllipsis]',
                exportAs: 'ngxNestedEllipsis'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { change: [{
            type: Output,
            args: ['nestedEllipsisChange']
        }], active: [{
            type: Input,
            args: ['nestedEllipsis']
        }], indicator: [{
            type: Input,
            args: ['nestedEllipsisIndicator']
        }], resizeDetection: [{
            type: Input,
            args: ['nestedEllipsisResizeDetection']
        }], wordBoundaries: [{
            type: Input,
            args: ['nestedEllipsisWordBoundaries']
        }], mayTruncateAtFn: [{
            type: Input,
            args: ['nestedEllipsisMayTruncateAtFn']
        }] }); })();

class NestedEllipsisModule {
}
NestedEllipsisModule.ɵfac = function NestedEllipsisModule_Factory(t) { return new (t || NestedEllipsisModule)(); };
NestedEllipsisModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NestedEllipsisModule });
NestedEllipsisModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NestedEllipsisModule, { declarations: [NestedEllipsisDirective, NestedEllipsisContentComponent], exports: [NestedEllipsisDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NestedEllipsisModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [NestedEllipsisDirective, NestedEllipsisContentComponent],
                entryComponents: [NestedEllipsisContentComponent],
                exports: [NestedEllipsisDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-nested-ellipsis
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NestedEllipsisContentComponent, NestedEllipsisDirective, NestedEllipsisModule };

//# sourceMappingURL=ngx-nested-ellipsis.js.map